(function(){
  var root = document.getElementById('lpd');
  if (!root || window.__lpDrawer) return;
  window.__lpDrawer = true;
  var onCart = document.body.classList.contains('lp-t-cart');
  var BEACH = 'BEACHCLUB-SET';

  function post(url, body){
    return fetch(url, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body)});
  }
  async function getCart(){ return (await fetch('/cart.js', {cache:'no-store', credentials:'same-origin'})).json(); }
  function codesOf(c){ return (c.discount_codes || []).map(function(d){ return d.code; }); }

  // keep the beach to beach club code only while a lara/lila set and a siren piece are both in the bag
  async function sync(){
    var c = await getCart();
    var h = c.items.map(function(i){ return i.handle; });
    var set = (h.indexOf('lara-bralette') > -1 && h.indexOf('lara-skirt') > -1) || (h.indexOf('lila-bralette') > -1 && h.indexOf('lila-skirt') > -1);
    var siren = c.items.some(function(i){ return /^(sand|porcelain|onyx)-/.test(i.handle); });
    var codes = codesOf(c), has = codes.indexOf(BEACH) > -1, next = null;
    if (set && siren && !has) next = codes.concat(BEACH);
    if (has && !(set && siren)) next = codes.filter(function(x){ return x !== BEACH; });
    if (next) await post('/cart/update.js', {discount: next.join(',')});
  }

  function say(text){ var m = root.querySelector('[data-lpd-msg]'); if (m) m.textContent = text || ''; }

  async function render(msg){
    try {
      var r = await fetch('/?sections=lp-cart-drawer', {cache:'no-store', credentials:'same-origin'});
      var j = await r.json();
      var d = document.createElement('div'); d.innerHTML = j['lp-cart-drawer'];
      var fresh = d.querySelector('#lpd');
      if (fresh) {
        root.querySelector('.lpd__panel').innerHTML = fresh.querySelector('.lpd__panel').innerHTML;
        var n = fresh.getAttribute('data-count');
        document.querySelectorAll('.lp-header__tools a[href="/cart"]').forEach(function(a){ a.textContent = 'bag (' + n + ')'; a.setAttribute('aria-label', 'bag, ' + n + ' items'); });
      }
    } catch(e) {}
    say(msg);
  }

  var lastFocus = null;
  function open(){
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lpd-lock');
    var x = root.querySelector('.lpd__x'); if (x) setTimeout(function(){ x.focus({preventScroll:true}); }, 50);
  }
  function close(){
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lpd-lock');
    document.body.style.removeProperty('overflow'); document.documentElement.style.removeProperty('overflow');
    if (lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
  }
  async function busy(fn){
    root.classList.add('is-busy');
    try { await fn(); } finally { root.classList.remove('is-busy'); }
  }

  async function addVariant(id, qty){
    var r = await post('/cart/add.js', {items:[{id: Number(id), quantity: qty || 1}]});
    if (!r.ok) { var j = {}; try { j = await r.json(); } catch(e){} throw new Error((j.description || 'that piece is no longer available.').toLowerCase()); }
    await sync();
  }

  // header "bag" opens the drawer
  window.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('.lp-header__tools a[href="/cart"]');
    if (a && !onCart) { e.preventDefault(); e.stopImmediatePropagation(); open(); busy(function(){ return render(); }); return; }
    if (!root.contains(e.target)) return;
    if (e.target.closest('[data-lpd-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-lpd-qty]');
    if (q) {
      e.preventDefault();
      busy(async function(){ await post('/cart/change.js', {line: Number(q.getAttribute('data-lpd-qty')), quantity: Number(q.getAttribute('data-q'))}); await sync(); await render(); });
      return;
    }
    var u = e.target.closest('[data-lpd-uncode]');
    if (u) {
      e.preventDefault();
      busy(async function(){ var c = await getCart(); var rm = u.getAttribute('data-lpd-uncode'); await post('/cart/update.js', {discount: codesOf(c).filter(function(x){ return x !== rm; }).join(',')}); await render(); });
    }
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  // forms: product page "add to bag", beach to beach club add-ons, drawer adds and member credit
  window.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || !f.matches) return;
    if (root.contains(f) && f.matches('[data-lpd-add]')) {
      e.preventDefault(); e.stopPropagation();
      var s = f.querySelector('select'); if (!s || !s.value) { if (s) s.focus(); return; }
      busy(async function(){ try { await addVariant(s.value); await render(); } catch(err) { await render(err.message); } });
      return;
    }
    if (root.contains(f) && f.matches('[data-lpd-code]')) {
      e.preventDefault(); e.stopPropagation();
      var code = (f.code.value || '').trim().toUpperCase(); if (!code) { f.code.focus(); return; }
      busy(async function(){
        var c = await getCart(), codes = codesOf(c);
        if (codes.indexOf(code) < 0) codes.push(code);
        await post('/cart/update.js', {discount: codes.join(',')});
        var c2 = await getCart();
        var hit = (c2.discount_codes || []).filter(function(d){ return d.code.toUpperCase() === code; })[0];
        if (!hit || !hit.applicable) {
          await post('/cart/update.js', {discount: codesOf(c2).filter(function(x){ return x.toUpperCase() !== code; }).join(',')});
          await render("that code can't be used on this order.");
        } else {
          await render(code === 'CLUBPRESTN' ? 'your member credit is applied. it is checked against your email at checkout.' : 'code applied.');
        }
      });
      return;
    }
    if (onCart) return;
    if (f.matches('[data-lp-product-form]') || f.classList.contains('lp-beach__form')) {
      e.preventDefault(); e.stopPropagation();
      var btn = f.querySelector('button[type="submit"], button:not([type])');
      var label = btn ? btn.textContent : '';
      var id;
      if (f.classList.contains('lp-beach__form')) { var sel = f.querySelector('select'); if (!sel || !sel.value) { if (sel) sel.focus(); return; } id = sel.value; }
      else { var inp = f.querySelector('input[name="id"]'); id = inp && inp.value; }
      if (!id) return;
      if (btn) { btn.disabled = true; btn.textContent = 'adding'; }
      (async function(){
        var msg = '';
        try { await addVariant(id); } catch(err) { msg = err.message; }
        await render(msg);
        if (btn) { btn.disabled = false; btn.textContent = label; }
        open();
      })();
    }
  }, true);
})();
